import { Component, OnInit } from '@angular/core';

const USER_DATA = [
  {
    valid:true,
    name: 'John Smith',
    invoiceNumber: 12345,
    invoiceDate: '1984-05-05',
    price: 36,
    containerNo: 2343456,
    sizeType: 654345678,

  },
  {valid: false,
    name: 'Muhi Masri',
    invoiceNumber: 765432,
    invoiceDate: '1992-02-02',
    price: 28,
    containerNo: 23432,
    sizeType: 654345678,
  },
  {valid: false,
    name: 'Peter Adams',
    invoiceNumber: 234452,
    invoiceDate: '2000-01-01',
    price: 20,
    containerNo: 12345432,
    sizeType: 654345678,
  },
  {valid: false,
    name: 'Lora Bay',
    invoiceNumber: 234329,
    invoiceDate: '1977-03-03',
    price: 43,
    containerNo: 123432345,
    sizeType: 654345678,
  },
];

const COLUMNS_SCHEMA = [
  {
    key:'valid',
    type:'boolean',
    label:'Validity',
  },
  {
    key: 'name',
    type: 'text',
    label: 'Vendor Name',
  },
  {
    key: 'invoiceNumber',
    type: 'number',
    label: 'Invoice number',
  },
  {
    key: 'invoiceDate',
    type: 'date',
    label: 'Invoice Date',
  },
  {
    key: 'price',
    type: 'number',
    label: 'Purchase price',
  },
  {
    key: 'containerNo',
    type: 'number',
    label: 'Container No',
  },
  {
    key: 'sizeType',
    type: 'text',
    label: 'Size-Type',
  },
  {
    key: 'condition',
    type: 'text',
    label: 'Condition',
  },
  {
    key: 'containerPurpose',
    type: 'text',
    label: 'Container Purpose',
  },
  {
    key: 'CSC',
    type: 'text',
    label: 'CSC Plate No',
  },
  {
    key: 'examinationDue',
    type: 'date',
    label: 'Next Examination',
  },
  {
    key: 'isEdit',
    type: 'isEdit',
    label: 'Edit',
  },
];

@Component({
  selector: 'app-editable-table',
  templateUrl: './editable-table.component.html',
  styleUrls: ['./editable-table.component.scss']
})
export class EditableTableComponent implements OnInit {
  displayedColumns: string[] = COLUMNS_SCHEMA.map((col) => col.key);
  dataSource = USER_DATA;
  columnsSchema: any = COLUMNS_SCHEMA;

  constructor() { }

  ngOnInit(): void {
  }

}
